import React, { useState } from "react";
import "../App.css";
import "leaflet/dist/leaflet.css";
import Map from "../Components/Map/Map";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import NavBar from "./NavBar";
import { useDispatch, useSelector } from "react-redux";

function MapPage() {
    const [open, setOpen] = useState(false);
    const themePallet = useSelector(state => state.main.theme)

    const onOpenModal = () => setOpen(true);
    const onCloseModal = () => setOpen(false);
    document.addEventListener('gesturestart', function (e) {
        e.preventDefault();
    });

    return (
        <div className="App" style={{ border: "4px solid " + themePallet.darkBackground, borderBottom: "6px solid " + themePallet.darkBackground }}>
            <NavBar />
            <Map onOpenModal={onOpenModal} onCloseModal={onCloseModal} />
            <Modal open={open} onClose={onCloseModal} center classNames={{ modal: process.env.REACT_APP_MODE_CLASS }}>
                <h2 className="modal-heading">
                    Location Disabled <ErrorOutlineIcon sx={{ color: process.env.REACT_APP_DARK_FONT + " !important" }} />{" "}
                </h2>
                <p className="location-request">
                    To get directions, please enable location services on your device.
                </p>
                <button className="btn-ok" onClick={onCloseModal} style={{ background: process.env.REACT_APP_DARK_BACKGROUND, color: process.env.REACT_APP_DARK_FONT, border: "1px solid " + process.env.REACT_APP_DARK_FONT }}>
                    Ok
                </button>
            </Modal>
        </div>
    );
}

export default MapPage;
